import { defineStore } from "pinia";
import { usePlanJoinStore } from "./PlanJoinStore";
import { PersonalInfo } from "~/entities/PersonalInfo";
import type { TransferInfo } from "~/entities/TransferInfo";
import { type IPersonalInfoRepository } from "~/interfaces/IPersonalInfoRepository";
import { PersonalInfoRepository } from "~/Repositories/PersonalInfoRepository";

export const usePersonalInfoStore = defineStore("PersonalInfoStore", () => {
  const planJoinStore = usePlanJoinStore();

  const repository: IPersonalInfoRepository = new PersonalInfoRepository();
  const personalInfo = ref<PersonalInfo>({});
  const transferInfo = ref<TransferInfo>({});
  const isEmailVerified = ref(false);
  const loading = ref(false);
  const searchAddressLoading = ref(false);

  const fetchPersonalInfo = async (planId?: string, userRole?: string) => {
    loading.value = true;
    try {
      personalInfo.value = await repository.get(planId, userRole);
    } finally {
      loading.value = false;
    }
  };

  const fetchTransferInfo = async () => {
    loading.value = true;
    try {
      transferInfo.value = await repository.get();
    } finally {
      loading.value = false;
    }
  };

  const fetchIsEmailVerified = async () => {
    loading.value = true;
    try {
      const personalInfo = await repository.get();
      // email が設定済み = メールアドレス認証済み
      isEmailVerified.value = !!personalInfo?.email && personalInfo.email.length > 0;
    } finally {
      loading.value = false;
    }
  };

  const savePersonalInfo = async () => {
    loading.value = true;
    try {
      await repository.save(personalInfo.value);
    } finally {
      loading.value = false;
    }
  };

  const saveTransferInfo = async () => {
    loading.value = true;
    try {
      const res = await repository.saveTransfer(transferInfo.value);
      planJoinStore.bankTransferId = res.bankTransferId;
    } finally {
      loading.value = false;
    }
  };

  const searchAddress = async (zipcode: string) => {
    searchAddressLoading.value = true;
    try {
      return await repository.searchAddress(zipcode);
    } finally {
      searchAddressLoading.value = false;
    }
  };

  return {
    personalInfo,
    transferInfo,
    isEmailVerified,
    loading,
    searchAddressLoading,
    fetchPersonalInfo,
    fetchTransferInfo,
    fetchIsEmailVerified,
    savePersonalInfo,
    saveTransferInfo,
    searchAddress,
  };
});
